import {RangeModel} from '../shared/range.model';
import {QuestionExtendedModel} from '../question-extended.model';

export class SingleDivisionModel extends QuestionExtendedModel {

  model = {
    firstRange: new RangeModel(),
    secondRange: new RangeModel(),
    possibleAnswers: new RangeModel(),
    numAnswers: 4,
    gridWidth: 0
  };

  static generateModel(json: any): SingleDivisionModel {

    const q = new SingleDivisionModel();

    const model = json.model;
    if (model) {

      if (model.firstRange) {
        q.model.firstRange = RangeModel.generateModel(model.firstRange);
      }

      if (model.secondRange) {
        q.model.secondRange = RangeModel.generateModel(model.secondRange);
      }

      if (model.possibleAnswers) {
        q.model.possibleAnswers = RangeModel.generateModel(model.possibleAnswers);
      }

      q.model.numAnswers = model.numAnswers;
      q.model.gridWidth = model.gridWidth;

    }

    return q;

  }

}
